import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { userLogin } from "../redux/postReducer/UserPost";
import { toast } from "react-toastify";
import ForgetPassword from "../Components/Reuseable/ForgetPassword";
import { Modal } from "react-bootstrap";
import "../Components/CSS/registration.css";
import { useTranslation } from "react-i18next";
import { BsEyeFill, BsChevronLeft } from "react-icons/bs";
import { requestForToken } from "../../firebaseNotifications/firebase";
import Cookies from "js-cookie";
import { clearData } from "../redux/getReducer/UserSlice";
import Logo from "../assets/logo-resizr.png";
import authBg from "../../Webiste/assets/Auth/auth_bg.jpg";
export const Login = () => {
  const { loading, userInfo, error } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [passwordShown, setPasswordShown] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = async () => await setShow(true);

  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const togglePasswordVisiblity = () => setPasswordShown(!passwordShown);

  useEffect(() => {
    if (userInfo) {
      navigate("/dashboard");
      requestForToken();
    }
  }, [navigate, userInfo]);

  const submitForm = async (data) => {
    await dispatch(userLogin(data));
  };

  useEffect(() => {
    if (error) {
      const err = error.data.message;
      const token = error.data.token;
      toast.error(err);
      if (err === "Email Not verified") {
        Cookies.set("token", token);
        navigate("/verifyemail");
        dispatch(clearData());
      }
    }
  }, [error, navigate, dispatch]);

  return (
    <div className="new-login-page-wrapper" style={{
      backgroundImage: `linear-gradient(rgba(11,17,54,0.8), rgba(11,17,54,0.8)), url(${authBg})`
    }}>
      {/* Top Right AR Language Section */}
      <div className="new-top-right-nav">
        {/* <b>AR</b>  */}
        {/* <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 10l5-5-5-5M7 14l-5 5 5 5" /><path d="M22 5H9a7 7 0 00-7 7v1M2 19h13a7 7 0 007-7v-1" /></svg> */}
      </div>

      <div className="new-login-card">
        {/* Card Header matching Image */}
        <div className="new-login-card-header">
          <div className="new-header-text-area">
            <BsChevronLeft
              className="new-back-arrow"
              onClick={() => navigate(-1)}
            />
            <div className="new-header-titles">
              <h3>{t("Welcome")}</h3>
              <p>{t("Sign In your account")}</p>
            </div>
          </div>
          <div className="new-header-logo">
            <img src={Logo} alt="Saddle Battle" />
          </div>
        </div>

        {/* Card Body - White Area */}
        <div className="new-login-card-body">
          <form onSubmit={handleSubmit(submitForm)}>
            <div className="new-input-group">
              <label>{t("Email")}</label>
              <div className="new-input-wrapper">
                <input
                  type="email"
                  className="new-form-input left-gap"
                  placeholder="TestUi@saddlebattles.com"
                  {...register("Email")}
                  required
                />
              </div>
            </div>

            <div className="new-input-group">
              <label>{t("password")}</label>
              <div className="new-input-wrapper">
                <input
                  type={passwordShown ? "text" : "password"}
                  placeholder="@Saddlebattles!"
                  className="new-form-input left-gap"
                  {...register("password")}
                  required
                />
                <span className="new-eye-btn" onClick={togglePasswordVisiblity}>
                  <BsEyeFill />
                </span>
              </div>
            </div>

            <div className="new-form-controls">
              <span className="new-forgot-link" onClick={handleShow}>
                {t("Forget Password?")}
              </span>
            </div>

            <button type="submit" className="new-signin-btn" disabled={loading}>
              {loading ? "Processing..." : t("Login")}
            </button>
          </form>
        </div>

        {/* Card Footer - Dark Navy Area */}
        <div className="new-login-card-footer">
          {t("Don't have an account?")}
          <Link to="/register" className="new-register-link">
            {t("Register Now here")}
          </Link>
        </div>
      </div>

      {/* Forget Password Modal (Logic kept same) */}
      {/* <Modal show={show} onHide={handleClose} size="lg" centered className='ForgetEmail1'>
        <Modal.Header closeButton className='ForgetEmailheader'>
          <h2 style={{ fontFamily: "Inter" }}>{t('ForgetEmail')} </h2>
        </Modal.Header>
        <Modal.Body className='ForgetEmailbody'>
          <ForgetPassword data={handleClose}/>
        </Modal.Body>
      </Modal> */}

      <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName="new-forget-modal-content"
        dialogClassName="new-forget-modal-dialog"
      >
        <Modal.Body style={{ padding: 0 }}>
          <ForgetPassword data={handleClose} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Login;
